import { Divider, Flex, Text } from '@spotify-internal/encore-web';

import { AuthConnectionsSection } from './AuthConnectionsSection';
import { useAuthConnectionsContext } from './CreateAccountFormProvider';
import { CreateWorkspaceFooter } from './CreateWorkspaceFooter';
import { RegionSection } from './RegionSection';
import { WorkspaceNameFields } from './WorkspaceNameFields';

import styles from './WorkspaceSetupForm.module.css';

export const WorkspaceSetupForm = () => {
  const { showAuthConnections } = useAuthConnectionsContext();

  return (
    <Flex className={styles.root} justifyContent="center">
      <div className={styles.wrapper}>
        <Flex
          className={styles.header}
          direction="column"
          gap="tighter-2"
          alignItems="center"
        >
          <Text as="h1" variant="titleMedium">
            Set up your workspace
          </Text>
          <Text variant="bodyMedium" semanticColor="textSubdued">
            Choose your workspace name carefully. It can&apos;t be changed
            later.
          </Text>
        </Flex>

        <WorkspaceNameFields />

        {showAuthConnections && (
          <section className={styles.section}>
            <Divider className={styles.divider} />
            <AuthConnectionsSection />
          </section>
        )}

        <section className={styles.section}>
          <Divider className={styles.divider} />
          <RegionSection />
        </section>

        <section className={styles.section}>
          <Divider className={styles.divider} />
          <CreateWorkspaceFooter />
        </section>
      </div>
    </Flex>
  );
};
